<template>
	<div class="filter-badges">
		<FilterBadge
			v-for="badge in badges"
			:key="`filter-badge-${badge.id}`"
			:badge="badge"
			@remove-filter="handleRemoveFilter"
		/>
		<FilterBadge
			type="clearAll"
			:badge="{ label: clearAllFiltersLabel }"
			@clear-filters="handleClearFilters"
		/>
	</div>
</template>

<script>
import FilterBadge from './FilterBadge.vue';
import bus from '@videotools/js/events';

export default {
	name:       'FilterBadges',
	components: {
		FilterBadge,
	},
	props: {
		badges: {
			type:    Array,
			default: () => [],
		},
		clearAllFiltersLabel: {
			type:    String,
			default: 'Clear all filters',
		},
	},
	methods: {
		handleRemoveFilter(id) {
			this.$emit('remove-filter', id);
		},
		handleClearFilters(evt) {
			bus.publish('dropdown:clear-selection');
			this.$emit('clear-filters', evt);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
